import React from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import ModalCloseButton from './ModalCloseButton.js';
import '../Icons/ModalsCloseIcon.js';

var css_248z = ".bwzmc{display:flex;font-size:16px;justify-content:space-between;line-height:1.5}[dir] .bwzmc{margin-bottom:20px;margin-top:20px}";
var styles = {"modal_header_container":"bwzmc"};
styleInject(css_248z);

const ModalHeaderWithCloseButton = ({ title, closeModal }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.modal_header_container }, /* @__PURE__ */ React.createElement("div", null, title), /* @__PURE__ */ React.createElement(ModalCloseButton, { closeModal }));
};

export { ModalHeaderWithCloseButton as default };
//# sourceMappingURL=ModalHeaderWithCloseButton.js.map
